import { SiteConfig } from "../../types";

export const _config: SiteConfig = {
  isDefault: false,
  showTidio: false,
  enableStripeBilling: false,
  serviceName: "Speakeno",
  publicUrl: "https://app.speakeno.com",
  pwaServiceName: "Speakeno",
  appLogoPath: "/partner/speakeno/logo.png",
  appLogoHeight: "30px",
  landingLogoPath: "/partner/speakeno/logo.png",
  landingLogoHeight: "30px",
  hubLogoPath: "/partner/speakeno/logo.png",
  hubLogoHeight: "30px",
  favicon: "/partner/speakeno/icon.png",
  pwaIcons: [
    {
      src: "/partner/speakeno/icon.png",
      type: "image/png",
      sizes: "192x192",
    },
  ],
  overrideLanding: true,
  emailsSender: "info@lang-services.com",
  adminEmail: "info@speakeno.com",
  adminPhoneNumber: "48572291193",
  whatsAppNumber: 48572291193,
  reviewLink: null,
  copyright: "Speakeno powered by BRITANNIA",
  showLanguageGuides: true,
  // supportLink: "https://speakeno.com/support",
  tocLink:
    "https://docs.google.com/document/d/1RiE0DLS8zaa_-0lhskoGsSRN1tgWN6Ah/edit?usp=sharing&ouid=112454690772119682599&rtpof=true&sd=true",
  privacyLink:
    "https://docs.google.com/document/d/1gZgmZ8v17ZvoK8AIaNSEamQVV6SvpTu5/edit?usp=sharing&ouid=112454690772119682599&rtpof=true&sd=true",
  bioPrompt: `
Welcome to Speakeno! I'm your AI speaking tutor, here to help you build confidence, fluency, and accuracy.
As one of many language tutors on Speakeno, I offer interactive conversation lessons for learners starting from lower intermediate level.
Whether for your career, study abroad, or everyday practice, my aim is to guide and support you in improving your practical communication skills in English, Italian, Spanish, German, and more, through real-world topics, targeted feedback, and personalised guidance at your level.
You're not a beginner, let's get you speaking with clarity, confidence, and purpose. Ready?
  `,
  siteColors: {
    special: {
      desktopSidebar: "#fff",
      desktopSidebarBorderColor: "#ddd",
      desktopSidebarText: "#000",
      desktopSidebarTextHover: "#eee",
      chatAsideMenu: "#111",
      mobileNavBackgroundColor: "#333",
      mobileNavBackgroundContrastColor: "#ffffff",
      mobileNavBorderColor: "#333",
      speakInputIdle: "var(--chakra-colors-brand-tertiary-600)",
      speakInputRecording: "var(--chakra-colors-brand-tertiary-800)",
      speakInputRecordingCancel: "var(--chakra-colors-brand-tertiary-900)",
    },
  },
  colors: {
    primary: {
      main: "#003274",
      mainContrast: "#fff",
      "50": "#f6f7fa",
      "100": "#dae1eb",
      "200": "#b9c7d9",
      "300": "#92a8c4",
      "400": "#7d96b8",
      "500": "#607fa8",
      "600": "#476b9b",
      "700": "#2c558c",
      "800": "#1a4782",
      "900": "#003171",
    },
    secondary: {
      main: "#E5097F",
      mainContrast: "#000",
      "50": "#fef5fa",
      "100": "#fbd6ea",
      "200": "#f7b1d7",
      "300": "#f280bd",
      "400": "#ee60ac",
      "500": "#e8258e",
      "600": "#cc0871",
      "700": "#a5075c",
      "800": "#8d064e",
      "900": "#68043a",
    },
    tertiary: {
      main: "#E5097F",
      mainContrast: "#000",
      "50": "#fef5fa",
      "100": "#fbd6ea",
      "200": "#f7b1d7",
      "300": "#f280bd",
      "400": "#ee60ac",
      "500": "#e8258e",
      "600": "#cc0871",
      "700": "#a5075c",
      "800": "#8d064e",
      "900": "#68043a",
    },
  },
};
